/**
 * "5 min ago", with the exact local time on hover. Re-renders itself:
 * most lists don't poll, and operators leave tabs open all day.
 */
import { useEffect, useState } from "react";
import { formatRelativeTime } from "@/lib/format";

const TICK_MS = 30_000;

export function RelativeTime({ iso }: { iso: string }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), TICK_MS);
    return () => clearInterval(t);
  }, []);
  return (
    <time dateTime={iso} title={new Date(iso).toLocaleString()} className="whitespace-nowrap text-xs">
      {formatRelativeTime(iso, now)}
    </time>
  );
}
